(function () {
  'use strict';

  function init() {
    // ── Tab switching ──────────────────────────────────────────────
    var tabs    = document.querySelectorAll('.account-tab');
    var contents = document.querySelectorAll('.account-tab-content');

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tabs.forEach(function (b) { b.classList.remove('is-active'); });
        contents.forEach(function (c) { c.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var target = document.getElementById('tab-' + btn.dataset.tab);
        if (target) target.classList.add('is-active');
      });
    });

    // ── Subscriptions fetch ────────────────────────────────────────
    var dataEl = document.getElementById('account-data');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var email = data.email;

    var loadingEl = document.getElementById('account-loading');
    var listEl    = document.getElementById('account-subs-list');

    function showEmpty() {
      if (loadingEl) loadingEl.style.display = 'none';
      if (listEl) listEl.innerHTML =
        '<p class="account-empty">Henüz aboneliğiniz bulunmuyor. ' +
        '<a href="/pages/siparis-olustur">Sipariş oluşturun</a> ' +
        've abonelik seçeneğini seçin.</p>';
    }

    if (!email) { showEmpty(); return; }

    var API = '/apps/hesabim/api/customer-subscriptions';

    // ── Helpers ────────────────────────────────────────────────────
    function freqLabel(f) {
      return { weekly: 'Haftada 1', biweekly: '2 Haftada 1', monthly: 'Ayda 1' }[f] || f;
    }
    function statusLabel(s) {
      return { active: 'Aktif', paused: 'Duraklatıldı', pending_payment: 'Beklemede', completed: 'Tamamlandı', cancelled: 'İptal' }[s] || s;
    }
    function statusClass(s) {
      return { active: 'badge--active', paused: 'badge--paused', pending_payment: 'badge--pending', completed: 'badge--done', cancelled: 'badge--cancelled' }[s] || '';
    }
    function formatDate(d) {
      if (!d) return '—';
      var p = d.split('-');
      return p.length < 3 ? d : p[2] + '.' + p[1] + '.' + p[0];
    }
    function formatMoney(n) {
      return Math.round(n).toLocaleString('tr-TR') + ' TL';
    }
    function deliveryStatusLabel(s) {
      return { scheduled: 'Planlandı', delivered: 'Teslim Edildi', skipped: 'Atlandı' }[s] || s;
    }

    // ── Render ─────────────────────────────────────────────────────
    function renderSubs(subs) {
      if (loadingEl) loadingEl.style.display = 'none';

      var active        = subs.filter(function (s) { return s.status === 'active'; });
      var totalDelivered = subs.reduce(function (acc, s) {
        return acc + (s.deliveries || []).filter(function (d) { return d.status === 'delivered'; }).length;
      }, 0);
      var nextDates = active.map(function (s) { return s.next_delivery_date; }).filter(Boolean).sort();

      var el = document.getElementById('stat-active');   if (el) el.textContent = active.length;
          el = document.getElementById('stat-delivered'); if (el) el.textContent = totalDelivered;
          el = document.getElementById('stat-next');      if (el) el.textContent = nextDates.length ? formatDate(nextDates[0]) : '—';

      if (!listEl) return;

      if (!subs.length) { showEmpty(); return; }

      listEl.innerHTML = subs.map(function (sub) {
        var dHtml = (sub.deliveries || []).map(function (d) {
          return '<div class="delivery-row delivery-row--' + d.status + '">' +
            '<span class="delivery-row__num">' + d.delivery_number + '.</span>' +
            '<span class="delivery-row__date">' + formatDate(d.scheduled_date) + '</span>' +
            '<span class="delivery-row__status">' + deliveryStatusLabel(d.status) + '</span>' +
          '</div>';
        }).join('');

        var blend = sub.blend_details;
        var beansHtml = '';
        if (blend && blend.beans && blend.beans.length) {
          beansHtml = '<div class="sub-card__beans">' +
            blend.beans.map(function (b) {
              return '<span class="sub-card__bean-tag">' + b.name + (blend.beans.length > 1 ? ' %' + b.ratio : '') + '</span>';
            }).join('') +
          '</div>';
        }

        return '<div class="sub-card">' +
          '<div class="sub-card__header">' +
            '<div>' +
              '<span class="sub-card__badge ' + statusClass(sub.status) + '">' + statusLabel(sub.status) + '</span>' +
              '<h3 class="sub-card__title">' + sub.duration_months + ' Aylık Abonelik</h3>' +
              beansHtml +
            '</div>' +
            '<div class="sub-card__price">' + formatMoney(sub.locked_price_per_kg) + '/kg</div>' +
          '</div>' +
          '<div class="sub-card__meta">' +
            '<div class="sub-card__meta-item"><span>Miktar</span><strong>' + sub.quantity_per_kg + ' kg</strong></div>' +
            '<div class="sub-card__meta-item"><span>Sıklık</span><strong>' + freqLabel(sub.delivery_frequency) + '</strong></div>' +
            '<div class="sub-card__meta-item"><span>Sonraki Teslimat</span><strong>' + formatDate(sub.next_delivery_date) + '</strong></div>' +
            '<div class="sub-card__meta-item"><span>Kalan</span><strong>' + sub.remaining_deliveries + ' / ' + sub.total_deliveries + '</strong></div>' +
          '</div>' +
          '<div class="sub-card__total">Toplam tutar: <strong>' + formatMoney(sub.locked_total_amount) + '</strong></div>' +
          refundHtml(sub) +
          (dHtml ? '<details class="sub-card__deliveries"><summary>Teslimat Takvimi</summary>' + dHtml + '</details>' : '') +
          subActionsHtml(sub) +
        '</div>';
      }).join('');
    }

    function refundHtml(sub) {
      if (sub.status !== 'cancelled') return '';
      var remaining = Number(sub.remaining_deliveries) || 0;
      if (remaining <= 0) return '';
      var refund = (Number(sub.locked_price_per_kg) || 0) * (Number(sub.quantity_per_kg) || 0) * remaining;
      if (refund <= 0) return '';
      return '<div class="sub-card__refund">' +
        '<div class="sub-card__refund-title">İade edilecek tutar</div>' +
        '<div class="sub-card__refund-amount">' + formatMoney(refund) + '</div>' +
        '<div class="sub-card__refund-note">Teslim edilmemiş ' + remaining + ' teslimatın bedeli. ' +
        'İadeniz ödeme yaptığınız yönteme (kartınıza) yapılacaktır. İşlem birkaç iş günü sürebilir.</div>' +
      '</div>';
    }

    // Abonelik Sözleşmesi (v1-2026-07-04): cayma/iptal yalnızca sipariş anından
    // itibaren 48 saat içinde. Sunucu da aynı kuralı uygular — bu sadece görünüm.
    var CANCEL_WINDOW_MS = 48 * 60 * 60 * 1000;
    function withinCancelWindow(sub) {
      var t = Date.parse(sub.created_at || '');
      return t && (Date.now() - t) < CANCEL_WINDOW_MS;
    }

    function subActionsHtml(sub) {
      var btns = '';
      var canCancel = withinCancelWindow(sub);
      if (sub.status === 'active') {
        btns += '<button class="sub-action sub-action--ghost" data-sub-action="pause" data-sub-id="' + sub.id + '">⏸ Duraklat</button>';
      } else if (sub.status === 'paused') {
        btns += '<button class="sub-action sub-action--primary" data-sub-action="resume" data-sub-id="' + sub.id + '">▶ Devam Ettir</button>';
      }
      if (btns && canCancel) {
        btns += '<button class="sub-action sub-action--danger" data-sub-action="cancel" data-sub-id="' + sub.id + '">İptal Et (48 saatlik cayma)</button>';
      }
      var note = '';
      if (btns && !canCancel) {
        note = '<p class="sub-card__nocancel">Abonelik Sözleşmesi gereği 48 saatlik cayma süresi dolmuştur; abonelik iptal edilemez. Teslimatları "Duraklat" ile öteleyebilirsiniz.</p>';
      }
      return btns ? '<div class="sub-card__actions">' + btns + '</div>' + note : '';
    }

    // ── Fetch with timeout ─────────────────────────────────────────
    function loadSubs() {
      var done = false;
      var timer = setTimeout(function () {
        if (!done) showEmpty();
      }, 5000);

      fetch(API + '?email=' + encodeURIComponent(email))
        .then(function (r) {
          done = true;
          clearTimeout(timer);
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function (d) { renderSubs(d.subscriptions || []); })
        .catch(function () {
          done = true;
          clearTimeout(timer);
          showEmpty();
        });
    }
    loadSubs();

    // ── Subscription actions (pause / resume / cancel) ─────────────
    var ACTION_API = '/apps/hesabim/api/subscription-action';
    var actionLabels = {
      pause:  'Aboneliği duraklatmak',
      resume: 'Aboneliğe devam etmek',
      cancel: 'Aboneliği iptal etmek',
    };
    if (listEl) {
      listEl.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.sub-action') : null;
        if (!btn) return;
        var action = btn.getAttribute('data-sub-action');
        var subId  = btn.getAttribute('data-sub-id');
        if (!action || !subId) return;

        var verb = actionLabels[action] || 'Bu işlemi yapmak';
        if (action === 'cancel' && !window.confirm('48 saatlik cayma hakkınızı kullanıyorsunuz: abonelik iptal edilecek ve ödemenizin tamamı iade edilecektir. Bu işlem geri alınamaz. Emin misiniz?')) return;

        var card = btn.closest('.sub-card');
        if (card) card.classList.add('sub-card--busy');
        btn.disabled = true;
        var oldText = btn.textContent;
        btn.textContent = 'İşleniyor…';

        fetch(ACTION_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ subscriptionId: subId, action: action }),
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body && res.body.error ? res.body.error : 'Hata');
            loadSubs();
          })
          .catch(function (err) {
            if (card) card.classList.remove('sub-card--busy');
            btn.disabled = false;
            btn.textContent = oldText;
            alert('İşlem tamamlanamadı: ' + (err.message || 'bilinmeyen hata'));
          });
      });
    }

    // ── Siparişler (App Proxy → Shopify Admin API) ─────────────────
    var ordersLoadingEl = document.getElementById('orders-loading');
    var ordersListEl    = document.getElementById('orders-list');

    function orderStatusLabel(s) {
      return {
        paid: 'Ödendi', pending: 'Beklemede', authorized: 'Onaylandı',
        partially_paid: 'Kısmen ödendi', refunded: 'İade edildi',
        partially_refunded: 'Kısmi iade', voided: 'İptal edildi'
      }[s] || (s || '—');
    }

    function ordersEscape(t) {
      return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function renderOrders(orders) {
      if (ordersLoadingEl) ordersLoadingEl.style.display = 'none';
      if (!ordersListEl) return;
      if (!orders.length) {
        ordersListEl.innerHTML =
          '<div class="orders-empty"><p>Henüz siparişiniz bulunmuyor.</p>' +
          '<a class="orders-empty__btn" href="/pages/siparis-olustur">Sipariş oluştur →</a></div>';
        return;
      }
      ordersListEl.innerHTML = orders.map(function (o) {
        var lines = (o.line_items || []).map(function (li) {
          return '<li class="order-line">' +
            '<span class="order-line__title">' + ordersEscape(li.title) + '</span>' +
            '<span class="order-line__meta">' + li.quantity + ' × ' + formatMoney(Number(li.price)) + '</span>' +
          '</li>';
        }).join('');
        var detail = o.order_status_url
          ? '<a class="order-card__detail" href="' + ordersEscape(o.order_status_url) + '" target="_blank" rel="noopener">Sipariş detayı →</a>'
          : '<span></span>';
        return '<div class="order-card">' +
          '<div class="order-card__top">' +
            '<div class="order-card__id">' +
              '<span class="order-card__name">' + ordersEscape(o.name) + '</span>' +
              '<span class="order-card__date">' + formatDate((o.created_at || '').slice(0, 10)) + '</span>' +
            '</div>' +
            '<div class="order-card__top-right">' +
              '<span class="order-badge order-badge--' + ordersEscape(o.financial_status) + '">' + orderStatusLabel(o.financial_status) + '</span>' +
              '<span class="order-card__total">' + formatMoney(Number(o.total_price)) + '</span>' +
            '</div>' +
          '</div>' +
          '<ul class="order-card__lines">' + lines + '</ul>' +
          '<div class="order-card__actions">' + detail +
            '<button class="order-reorder" type="button" data-order-id="' + ordersEscape(o.id) + '">' +
              '<span class="order-reorder__label">↻ Tekrar sipariş ver</span>' +
            '</button>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    function loadOrders() {
      if (!ordersListEl) return;
      var done = false;
      var t = setTimeout(function () { if (!done) renderOrders([]); }, 6000);
      fetch('/apps/hesabim/api/customer-orders')
        .then(function (r) { done = true; clearTimeout(t); if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) { renderOrders(d.orders || []); })
        .catch(function () {
          done = true; clearTimeout(t);
          if (ordersLoadingEl) ordersLoadingEl.style.display = 'none';
          if (ordersListEl) ordersListEl.innerHTML =
            '<div class="orders-empty"><p>Siparişler yüklenirken bir sorun oluştu. Lütfen sayfayı yenileyin.</p></div>';
        });
    }
    loadOrders();
  }

  // ── Profile form ───────────────────────────────────────────────
  function initProfileForm() {
    var form        = document.getElementById('profile-form');
    var saveBtn     = document.getElementById('profile-save-btn');
    var statusEl    = document.getElementById('profile-save-status');
    var sameChk     = document.getElementById('pf-same-address');
    var shipFields  = document.getElementById('shipping-fields');
    if (!form) return;

    var dataEl = document.getElementById('account-data');
    if (!dataEl) return;
    var accountData;
    try { accountData = JSON.parse(dataEl.textContent); } catch (_) { return; }
    var email = accountData.email;
    if (!email) return;

    var API_PROFILE  = '/apps/hesabim/api/customer-profile';
    var API_CUSTOMER = '/apps/hesabim/api/update-customer';

    // Show/hide shipping fields
    function toggleShipping() {
      if (shipFields) shipFields.style.display = sameChk && sameChk.checked ? 'none' : 'block';
    }
    if (sameChk) sameChk.addEventListener('change', toggleShipping);

    // Load saved profile from Supabase
    fetch(API_PROFILE + '?email=' + encodeURIComponent(email))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var p = d.profile;
        if (!p) return;
        function setVal(id, val) {
          var el = document.getElementById(id);
          if (el && val) el.value = val;
        }
        setVal('pf-company',        p.company_name);
        setVal('pf-tax-id',         p.tax_id);
        setVal('pf-tax-office',     p.tax_office);
        setVal('pf-billing-street', p.billing_street);
        setVal('pf-billing-district', p.billing_district);
        setVal('pf-billing-city',   p.billing_city);
        setVal('pf-billing-zip',    p.billing_zip);
        if (sameChk) sameChk.checked = p.shipping_same_as_billing !== false;
        setVal('pf-ship-street',    p.shipping_street);
        setVal('pf-ship-district',  p.shipping_district);
        setVal('pf-ship-city',      p.shipping_city);
        setVal('pf-ship-zip',       p.shipping_zip);
        toggleShipping();
      })
      .catch(function () {});

    function fieldVal(name) {
      var el = form.elements[name];
      return el ? el.value.trim() : '';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      saveBtn.disabled    = true;
      saveBtn.textContent = 'Kaydediliyor...';
      statusEl.textContent = '';
      statusEl.className   = 'profile-save-status';

      var sameAddr = sameChk ? sameChk.checked : true;

      // Save personal info to Shopify
      var p1 = fetch(API_CUSTOMER, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          email:     email,
          firstName: fieldVal('firstName'),
          lastName:  fieldVal('lastName'),
          phone:     fieldVal('phone'),
        }),
      }).then(function (r) { return r.json(); });

      // Save business profile to Supabase
      var p2 = fetch(API_PROFILE, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          email:                   email,
          company_name:            fieldVal('company_name'),
          tax_id:                  fieldVal('tax_id'),
          tax_office:              fieldVal('tax_office'),
          billing_street:          fieldVal('billing_street'),
          billing_district:        fieldVal('billing_district'),
          billing_city:            fieldVal('billing_city'),
          billing_zip:             fieldVal('billing_zip'),
          shipping_same_as_billing: sameAddr,
          shipping_street:         sameAddr ? '' : fieldVal('shipping_street'),
          shipping_district:       sameAddr ? '' : fieldVal('shipping_district'),
          shipping_city:           sameAddr ? '' : fieldVal('shipping_city'),
          shipping_zip:            sameAddr ? '' : fieldVal('shipping_zip'),
        }),
      }).then(function (r) { return r.json(); });

      Promise.all([p1, p2])
        .then(function (results) {
          saveBtn.disabled    = false;
          saveBtn.textContent = 'Kaydet';
          var shopifyOk = results[0].ok;
          var supabaseOk = results[1].ok;
          if (shopifyOk && supabaseOk) {
            statusEl.textContent = 'Bilgiler kaydedildi.';
            statusEl.className   = 'profile-save-status profile-save-status--ok';
            var greeting = document.querySelector('.account-greeting');
            if (greeting && (results[0].firstName || results[0].lastName)) {
              greeting.textContent = ((results[0].firstName || '') + ' ' + (results[0].lastName || '')).trim();
            }
          } else {
            var err = results[0].error || results[1].error || 'Bir hata oluştu.';
            statusEl.textContent = err;
            statusEl.className   = 'profile-save-status profile-save-status--err';
          }
        })
        .catch(function () {
          saveBtn.disabled    = false;
          saveBtn.textContent = 'Kaydet';
          statusEl.textContent = 'Bağlantı hatası.';
          statusEl.className   = 'profile-save-status profile-save-status--err';
        });
    });
  }

  // ── Tekrar sipariş ver ─────────────────────────────────────────
  function initReorder() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.order-reorder');
      if (!btn) return;
      var orderId = btn.getAttribute('data-order-id');
      if (!orderId || btn.disabled) return;

      var label = btn.querySelector('.order-reorder__label');
      var original = label ? label.textContent : btn.textContent;
      btn.disabled = true;
      if (label) label.textContent = 'Hazırlanıyor...';

      fetch('/apps/hesabim/api/reorder', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderId: orderId }),
      })
        .then(function (res) { return res.json().then(function (d) { if (!res.ok) throw new Error(d.error || 'Hata'); return d; }); })
        .then(function (data) { window.location.href = data.checkoutUrl; })
        .catch(function (err) {
          btn.disabled = false;
          if (label) label.textContent = original;
          alert('Tekrar sipariş oluşturulamadı: ' + (err.message || 'bilinmeyen hata'));
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initProfileForm(); initReorder(); });
  } else {
    init();
    initProfileForm();
    initReorder();
  }
})();
